<template lang="html">
  <div class="gallery-image-container col-6 col-sm-6 col-md-3 py-3">
    <div
      class="gallery-image"
      :style="`background-image: url(${imageWithExtensionSmall(img.image_file_name)});`">
    </div>
    <Tooltip v-if="starred"
             class="gallery-image-tooltip starred"
             position="right"
             noTip
             gray
             :text="'Imagen principal'"
             noClose>
      <div class="gallery-image-button text-center">
        <div class="fa fa-star" style="margin: auto"></div>
      </div>
    </Tooltip>
    <Tooltip v-else
             class="gallery-image-tooltip"
             noTip
             gray
             :text="'Seleccionar como imagen principal'"
             noClose>
      <button @click="$emit('star', img.id)"
              class="gallery-image-button btn btn-outline-secondary">
        <span class="fa fa-star"></span>
      </button>
    </Tooltip>
    <button v-if="deletable"
            @click="$store.dispatch('sell/deleteImage', img.id)"
            class="gallery-image-delete btn btn-outline-secondary">
      <span class="fa fa-times"></span>
    </button>
  </div>
</template>

<script>
import { imageWithExtensionSmall } from '@/helpers'
import store from '@/store'

export default {
  props: {
    img: Object,
    starred: Boolean,
    deletable: Boolean
  },

  methods: {
    imageWithExtensionSmall
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/breakpoints';

  .gallery-image {
    background-color: gray;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;

    &-container {
      height: 150px;
      width: 150px;
      display: inline-block;
      padding: 1rem 0.5rem;
    }


    &-tooltip {
      opacity: 0;
      position: absolute;
      top: 1rem;
      left: 0.5rem;
      border-radius: 4px;

      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        opacity: 0.65;
      }

      &:hover {
        opacity: 1;
      }
    }

    &-button {
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      border: none;
      background-color: lightgrey;
      border-radius: 4px;

      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        line-height: 2;
      }
    }

    &-delete {
      position: absolute;
      top: 1rem;
      right: 0.5rem;
      opacity: 0;
      border: none;
      background-color: lightgrey;
      border-radius: 4px;

      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        opacity: 0.65;
      }

      &:hover {
        opacity: 1;
      }
    }

    &:hover ~ .gallery-image-delete {
      opacity: 0.65;
      background-color: lightgrey;
    }

    &:hover ~ .gallery-image-tooltip {
      opacity: 0.65;
      background-color: lightgrey;
    }
  }

  .starred {
    display: flex;
    opacity: 1 !important;
    height: 36px;
    width: 38px;
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/gallery/GalleryImage.vue